import type { SerializedDocument } from '@enmon/commons/lib/tools';
import type { StrictOmit } from '@enmon/commons';
import type { ParseDocumentsData } from '@enmon/commons/lib/tools';
import { BaseApiClient } from './baseApiClient';

export type DocumentsFilter = {
  search: string | null;
  customer: string | null;
  status: string | null;
};

export interface CreateDocumentArgs {
  customer: string | number;
  file: File | Blob;
}

export type ParseDocumentsArgs = StrictOmit<ParseDocumentsData, 'user' | 'failedDocuments'>;

export class DocumentsApiClient extends BaseApiClient {
  constructor(jwt: string) {
    super('documents', undefined, jwt);
  }

  public async create({ customer, file }: CreateDocumentArgs): Promise<SerializedDocument> {
    const formData = new FormData();
    formData.append('files.file', file);
    const JSONForm = JSON.stringify({ customer });
    formData.append('data', JSONForm);
    const response = await this.axios.post<SerializedDocument>('', formData);
    return response.data;
  }

  public async parseDocuments(args: ParseDocumentsArgs): Promise<unknown> {
    return await this.axios.post('/parse', args);
  }

  public async delete(id: SerializedDocument['id']): Promise<void> {
    await this.axios.delete(`${id}`);
  }
}
